<div
	class="overlay-wrapper"
	style.padding="{{ ui.Spacing.SPACING_LARGE }}"
>
	@if (context) {
		<ada-object-table
			[allowMultiple]="true"
			[checkboxesEnabled]="true"
			[headerMenuRef]="HeaderMenu"
			[includeActionsColumn]="true"
			[includeHeaderMenu]="true"
			[queryConfiguration]="queryConfig()"
			[rowMenuRef]="RowMenu"
			[selectionContext]="true"
			[staticFilterCondition]="context.staticFilterCondition"
			(selectedNodesChange)="setSelections($event)"
		/>
		<ada-menu
			#RowMenu
			[controller]="menuController"
		/>
		<ada-menu
			#HeaderMenu
			[controller]="menuHeaderController"
		/>
	}
</div>
